export enum RestrictedActionTrackEventName {
  Blocked = 'Restricted Action Blocked',
}
